import * as themeKeyMap from './themeMap.json';
import { Constants } from '../common/Constants';
import { ThemeId } from '../common/EnumTypes';
import { ThemeKeyMap } from '../common/InternalTypes';
import { Logger } from '../common/Logger';
import { LoggerTexts } from '../common/LoggerTexts';
import { ThemingConfig } from '../config/ThemingConfig';
import { ContextDataController } from '../data/ContextDataController';

export class GenericTheming {
	private readonly _logger: Logger;
	private readonly _themingConfig: ThemingConfig;
	private readonly _contextDataController: ContextDataController;
	private _themeKeyMap: ThemeKeyMap;

	constructor(themingConfig: ThemingConfig, contextDataController: ContextDataController) {
		this._logger = new Logger(Constants.FILE_GENERIC_THEMING);
		this._themingConfig = themingConfig;
		this._contextDataController = contextDataController;
		this._loadThemeKeyMap();
	}

	public updateCurrentTheme(themeId: ThemeId) {
		if (this._themeKeyMap) {
			if (themeId === ThemeId.none) {
				this._contextDataController.resetThemingContextData();
			} else if (this._themingConfig.writeToGlobals) {
				const themeValues = this._themeKeyMap[themeId];
				this._contextDataController.setThemingDataContext(themeValues);
			}
		} else {
			this._logger.error(LoggerTexts.THEME_VALUE_FETCHER.LOAD_KEY_MAP_ERROR);
		}
	}

	private _loadThemeKeyMap() {
		if (themeKeyMap) {
			this._themeKeyMap = themeKeyMap as ThemeKeyMap;
		}
	}
}
